import { render, staticRenderFns } from "./DataHome.vue?vue&type=template&id=b1f073e6&scoped=true"
import script from "./DataHome.vue?vue&type=script&lang=js"
export * from "./DataHome.vue?vue&type=script&lang=js"
import style0 from "./DataHome.vue?vue&type=style&index=0&id=b1f073e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f073e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1f073e6')) {
      api.createRecord('b1f073e6', component.options)
    } else {
      api.reload('b1f073e6', component.options)
    }
    module.hot.accept("./DataHome.vue?vue&type=template&id=b1f073e6&scoped=true", function () {
      api.rerender('b1f073e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataset/data/DataHome.vue"
export default component.exports